import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './globals.css';

console.log("main.tsx: script execution start");
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("main.tsx: #root element NOT found in DOM");
} else {
  console.log("main.tsx: #root element found, starting concurrent render");
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log("main.tsx: root created");
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log("main.tsx: render() called successfully");
  } catch (err) {
    console.error("main.tsx: render() failed", err);
  }
}
